import React from "react";
import { Outlet } from "react-router-dom";
import Menu from "../components/menu";
import Footer from "../components/footer";

const PublicLayout = () => {
  return (
    <div className="main-layout">
      <Menu />
      <main>
        <Outlet /> {/* Aquí se renderizan Home, Ofertas, Login, etc. */}
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
